import { getDevMode } from '../devUtils';
import { getHeaders } from '../utils';
import type { IPlatformContext } from './types';

export const detectPlatform = (): IPlatformContext => {
  const headersList = getHeaders();
  const userAgent = headersList.get('user-agent');
  const xClient = headersList.get('x-client');

  // If in development mode, return the dev mode context.
  const devMode = getDevMode();
  if (devMode) {
    return {
      isMobileApp: devMode?.isAppMode,
      isMarketingPage: devMode?.isMarketingMode,
      userAgent,
      xClient,
    };
  }

  // If not in development mode, detect the platform based on the user agent.
  const isInWebView =
    // prettier-ignore
    xClient === 'RNWebView' ||
    userAgent?.includes('Patchooli/1.0') ||
    userAgent?.includes('RNWebView') ||
    false;

  // In Production, we serve the Patchooli Application Experience when the app is in a web view.
  const isMobileApp = isInWebView;
  // and we serve the Patchooli Marketing Site when the app is in a browser.
  const isMarketingPage = !isInWebView;

  return {
    isMobileApp,
    isMarketingPage,
    userAgent,
    xClient,
  };
};
